<div
  data-testid="generator-sentences"
  class="mx-5"
>
  <ng-container *ngIf="sentences">
    <header class="d-flex align-items-center justify-content-between sticky-top bg-white py-3 border-bottom">
      <div class="d-flex align-items-center gap-3">
        <h1 class="h2 mb-1">{{ "reportGeneratorSentencesPageTitle" | localize }}</h1>

        <div>
          <button
            class="btn btn-sm btn-outline-secondary me-1"
            [ngClass]="{active: activeExternalAnalysisType === 'CAS'}"
            data-testid="cas-sentences-button"
            (click)="showSentencesFor('CAS')"
          >
            {{ "generatorSentencesCasTabLabel" | localize }}
          </button>
          <button
            class="btn btn-sm btn-outline-secondary"
            [ngClass]="{active: activeExternalAnalysisType === 'CARDIOLOGS'}"
            data-testid="cardiologs-sentences-button"
            (click)="showSentencesFor('CARDIOLOGS')"
          >
            {{ "generatorSentencesCardiologsTabLabel" | localize }}
          </button>
        </div>
      </div>

      <action-button
        buttonType="button"
        [buttonLabel]="'editGeneratorSentencesSaveButtonLabel'"
        [actionInProgressLabel]="'editGeneratorSentencesSaveInProgressButtonLabel'"
        buttonClass="btn btn-primary"
        [testId]="'save-generator-sentences-button'"
        [actionInProgress]="savingInProgress"
        (buttonClick)="saveSentences()"
      ></action-button>
    </header>

    <form class="d-flex flex-column gap-4 pt-4">
      <section *ngFor="let group of groups; index as i">
        <h2 class="h6 mb-3">{{ group.key }}</h2>

        <div class="input-group mb-2" *ngFor="let language of supportedLanguages">
          <span class="input-group-text">{{ language.flag }}</span>
          <input
            [attr.data-testid]="'generator-sentence-' + language.code + '-' + i"
            type="text"
            class="form-control"
            [value]="group.sentencesByLanguage[language.code] || ''"
            (input)="setSentence(group, language.code, $event)"
          />
        </div>
      </section>
    </form>
  </ng-container>
  <div class="alert alert-danger" *ngIf="gettingSentencesFailed">
    {{ 'generatorSentencesFetchError' | localize }}
  </div>

  <div *ngIf="sentences === undefined && !gettingSentencesFailed">
    <loading-indicator [label]="'generatorSentencesFetchInProgress'"></loading-indicator>
  </div>

</div>
